import { render, staticRenderFns } from "./IntegrationListDetail.vue?vue&type=template&id=66e54f5f&"
import script from "./IntegrationListDetail.vue?vue&type=script&lang=js&"
export * from "./IntegrationListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports